import { ButtonGroup, Whisper, IconButton } from 'rsuite';
import ThemeButton from '@shared/ui/buttons/ThemeButton';
import { useRef } from 'react';
import { icons } from '@shared/static/icons';

export default function SplitButton({
  menuComponent: MenuComponent,
  menuProps = {},
  text,
  icon,
  action,
}) {
  const whisperRef = useRef();

  const close = () => {
    whisperRef.current?.close?.();
  };

  return (
    <ButtonGroup divided className="split-btn">
      <ThemeButton
        block={false}
        appearance="secondary"
        startIcon={icon}
        onClick={action}
      >
        {text}
      </ThemeButton>
      <Whisper
        ref={whisperRef}
        placement="auto"
        trigger="click"
        speaker={<MenuComponent {...menuProps} close={close} />}
      >
        <IconButton appearance="secondary" icon={icons['chevron-down']} />
      </Whisper>
    </ButtonGroup>
  );
}
